const safeNumber = (value) => {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

export const sumMonthlyMarkdownPlan = (rows = []) => {
  return (Array.isArray(rows) ? rows : []).reduce((acc, row) => {
	return acc + safeNumber(row?.markdownPlan ?? row?.markdown_plan ?? row?.markdowns_plan)
  }, 0)
}

export const deriveMonthlyMarkdownPercent = ({ markdownPlan, annualMarkdownPlan }) => {
  const total = safeNumber(annualMarkdownPlan)
  if (!(total > 0)) return 0
  return (safeNumber(markdownPlan) / total) * 100
}

export const deriveMonthlyMarkdownValue = ({ markdownPlanPercent, annualMarkdownPlan }) => {
  const total = safeNumber(annualMarkdownPlan)
  if (!(total > 0)) return 0
  return total * (safeNumber(markdownPlanPercent) / 100)
}

